import {
  CryptoNetDictionaryResponse,
  DictionariesService,
  ResponseData_CryptoNetDictionaryResponse,
} from '@acme/api';

type NetsApiResponse = ResponseData_CryptoNetDictionaryResponse & {
  data?: CryptoNetDictionaryResponse[] | null;
};

class NetStore {
  private nets: CryptoNetDictionaryResponse[] | null = null;
  private loadingPromise: Promise<CryptoNetDictionaryResponse[]> | null = null;
  private error: Error | null = null;

  async getNets(): Promise<CryptoNetDictionaryResponse[]> {
    if (this.nets) {
      return this.nets;
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = (async () => {
      try {
        const response =
          (await DictionariesService.getApiV1DictionariesNets()) as NetsApiResponse;

        if (!response?.data?.length) {
          throw new Error('No data received from nets API');
        }

        const nets = response.data.filter(
          (net): net is CryptoNetDictionaryResponse =>
            net !== null && net !== undefined
        );

        if (nets.length === 0) {
          throw new Error('No valid nets data received from nets API');
        }

        this.nets = nets;

        return this.nets;
      } catch (err) {
        this.error =
          err instanceof Error ? err : new Error('Failed to load nets');
        throw this.error;
      } finally {
        this.loadingPromise = null;
      }
    })();

    return this.loadingPromise;
  }
}

export const netStore = new NetStore();
